import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getAdvocate } from "../../helper/API/advocate";
import { addSubscriber, getSingleProcess } from "../../helper/API/process";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const theme = createTheme({
  typography: {
    body1: {
      // fontSize: 22,
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: 22,
          },
        },
        input: {
          fontSize: 22,
        },
        listbox: {
          fontSize: 22,
        },
      },
    },
  },
});

const StyledAutocomplete = styled(Autocomplete)({
  "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
    fontSize: 22,
  },
});
const Option = styled("li")({
  fontSize: 22,
});

const AdvocateModal = ({ open, handleClose, TaskDetail, data, singleProcessData, setSingleProcessData }) => {
  const [value, setValue] = React.useState(null);

  const arrangeData = data?.map((label, indx) => {
    return { label: label.name, id: label.id };
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // console.log("newValue", newValue);
    const submitData = {
      subscriberId: newValue.id,
      processId: TaskDetail.id,
      userType: "advocate",
    };
    // console.log("submitData", submitData);
    addSubscriber(submitData).then(res => {
      if (res.success) {
        toast.success(res.message);
        const id = { id: TaskDetail.id };
        getSingleProcess(id).then(res => {
          if (res.success) {
            setSingleProcessData(res.data);
          }
          handleClose();
        });
      } else {
        toast.error(res.message);
        handleClose();
      }
    });
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Advogados</h3>
          <h3>
            <CloseIcon onClick={handleClose} sc={{ cursor: "pointer" }} />
          </h3>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 15, mt: 3, height: "30vh" }}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={arrangeData}
              renderOption={(props, option) => (
                <li key={option} {...props}>
                  <Typography className="font-large yourDesiredClass">{option.label}</Typography>
                </li>
              )}
              noOptionsText={"Nenhuma opção disponível"}
              onChange={handleChange}
              sx={{ position: "relative", zIndex: 500 }}
              renderInput={params => <TextField {...params} label="Advogados" sx={{ mt: 1 }} />}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default AdvocateModal;
